// extracted by mini-css-extract-plugin
export default {"h3":"H3-module__h3___99se8","bold":"H3-module__bold___M6MfW","muted":"H3-module__muted___czYj0","inline":"H3-module__inline___gg2H4"};